import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  headerRow: {
    marginBottom: theme.spacing(2),
  },
  // Standard filter zone (mirrors chassis-list / controls-list).
  filtersContainer: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0 1px 5px 0 rgba(227, 227, 236, 0.8)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterContainerTitleText: {
    color: theme.palette.captGrey.main,
  },
  actionsContainer: {
    marginTop: '10px',
  },
  tableContainer: {
    background: 'white',
    borderRadius: '5px',
    boxShadow: '0 1px 5px 0 rgba(227, 227, 236, 0.8)',
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  table: {
    boxShadow: '0 0px 0px 0 rgba(0, 0, 0, 0)',
    // Align the toolbar (grand-total title) with the first column header.
    '& .MuiToolbar-root': {
      paddingLeft: theme.spacing(2),
    },
  },
  tableTitle: {
    fontWeight: 700,
  },
  titleWithInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  kpiValue: {
    fontSize: 28,
    fontWeight: 700,
  },
  kpiLabel: {
    color: theme.palette.text.secondary,
  },
  exportButton: {
    marginLeft: theme.spacing(1),
  },
  // The export SVG ships with a hardcoded white fill; override it to the
  // primary color so it reads on the outlined (white) buttons.
  exportIcon: {
    '& path': {
      fill: theme.palette.primary.main,
    },
  },
  subtotalCell: {
    fontWeight: 700,
  },
  totalCell: {
    fontWeight: 700,
    background: theme.palette.action.hover,
  },
}))
